import React, { useContext, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { H6 } from '@luigiclaudio/ga-baseline-ui/typography';
import { useFormikContext } from 'formik';
import ColorVariantContainer from './ColorVariantContainer';
import ColorNameTitle from './ColorNameTitle';
import ColorNameLabel from './ColorNameLabel';
import ColorNameLicense from '../../../ColorNameLicense';
import ColorToolsContext from '../../../context/ColorToolsContext';
import colorToolsUtils from '../../../../utils/colorToolsUtils';
import ColorVariant from '../../../ColorVariant';

const ColorEntryVariant = ({ name, show }) => {
    const { values } = useFormikContext();
    const { setColorOnStage } = useContext(ColorToolsContext);

    const renderColorName = useMemo(() => colorToolsUtils.colorName(values[name]), [values[name]]);

    useEffect(() => {
        setColorOnStage(values[name]);
    }, [values]);

    if (!show) {
        return null;
    }

    return (
        <ColorVariantContainer>
            <ColorNameTitle>
                <H6 color="muted">
                    <ColorNameLabel>
                        <ColorNameLicense>{renderColorName}</ColorNameLicense>
                    </ColorNameLabel>
                </H6>
            </ColorNameTitle>
            <ColorVariant colorVariant={`#${values[name]}`} />
        </ColorVariantContainer>
    );
};

ColorEntryVariant.propTypes = {
    name: PropTypes.string.isRequired,
    show: PropTypes.bool,
};

ColorEntryVariant.defaultProps = {
    show: undefined,
};

export default ColorEntryVariant;
